import React, { createContext, useContext, useReducer, ReactNode } from 'react'

type VehicleIdType = string

export type MilageEntryType = {
  value: number
  updatedAt: number
}

type MilageStateType = Record<VehicleIdType, MilageEntryType>

type ActionType = { type: 'SET_VALUE'; vehicleId: VehicleIdType | undefined; value: number }

function reducer(state: MilageStateType, action: ActionType): MilageStateType {
  switch (action.type) {
    case 'SET_VALUE': {
      if (!action.vehicleId) return state
      const newValue = Number(action.value)

      return {
        ...state,
        [action.vehicleId]: { value: newValue, updatedAt: Date.now() },
      }
    }
    default:
      return state
  }
}

const MilageStateContext = createContext<MilageStateType | undefined>(undefined)
const MilageDispatchContext = createContext<React.Dispatch<ActionType> | undefined>(undefined)

export function MilageProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(reducer, {})
  return (
    <MilageDispatchContext.Provider value={dispatch}>
      <MilageStateContext.Provider value={state}>{children}</MilageStateContext.Provider>
    </MilageDispatchContext.Provider>
  )
}

export function useMilageValue(vehicleId?: string) {
  const state = useContext(MilageStateContext)
  if (!state || !vehicleId) return undefined
  return state[vehicleId]?.value
}

export function useMilageDispatch() {
  const dispatch = useContext(MilageDispatchContext)
  if (!dispatch) throw new Error('useMilageDispatch must be used within MilageProvider')
  return dispatch
}
